export default __webpack_public_path__ + "static/media/product-12 (2).54514ffa.jpg";